module.exports = __webpack_public_path__ + "img/6150a18.png";